import { useEffect, useState } from 'react';

import type { RefObject } from 'react';

export const useResizeObserver = (
  elementRef: RefObject<Element | null>,
): ResizeObserverEntry | undefined => {
  const [entry, setEntry] = useState<ResizeObserverEntry>();
  const updateEntry = ([entry]: ResizeObserverEntry[]): void => {
    setEntry(entry);
  };

  useEffect(() => {
    const node = elementRef?.current; // DOM Ref
    const hasIOSupport = !!window.ResizeObserver;

    if (!hasIOSupport || !node) return;

    const observer = new ResizeObserver(updateEntry);

    observer.observe(node);

    return () => observer.disconnect();
  }, [elementRef]);

  return entry;
};
